 jQuery(document).ready(function() {
     jQuery('.menu__has_children').hover(
         function() {
             var $this = jQuery(this);
             clearTimeout($this.data('timeout'));
             $this.data('timeout', setTimeout(function() {
                 jQuery('.mega__menu').removeClass('active');
                 jQuery('.menu__has_children').removeClass('active-item');
                 if ($this.find('.mega__menu').length) {
                     $this.find('.mega__menu').addClass('active');
                     $this.find('a').first().addClass('active-item');
                 }
             }, 300)); // Adjust the delay time as needed
         },
         function() {
             var $this = jQuery(this);
             clearTimeout($this.data('timeout'));
             $this.data('timeout', setTimeout(function() {
                 jQuery('.mega__menu').removeClass('active');
                 jQuery('.menu__has_children > a').removeClass('active-item');
             }, 20)); // Adjust the delay time as needed
         }
     );


     jQuery('.btn-close-menu').on('click', function() {
         jQuery('.mega__menu').removeClass('active');
         jQuery('.menu__has_children > a').removeClass('active-item');
     })
     jQuery('.color-swatch-label').hover(function() {
         jQuery(this).find('.tooltip').show();
     }, function() {
         jQuery('.tooltip').hide();
     });
     jQuery('body').on('click', '.color-swatch-label', function() {
         var that = this;
         var swatches = document.querySelectorAll('.color-swatch-label');

         // Remove 'selected' class from all swatches
         swatches.forEach(function(otherSwatch) {
             // otherSwatch.classList.remove('selected');
         });
         jQuery(that).closest('.product-block').find('.color-swatch-label').removeClass('selected');

         // Add 'selected' class to clicked swatch
         jQuery(that).addClass('selected');

         // Get the variant ID from the clicked swatch
         var variantId = jQuery(that).data('variant');
         var product_handle = jQuery(that).data('product');
         var product_url = jQuery(that).data('purl');

         // Fetch the variant data via AJAX
         fetch(`/products/${product_handle}/variant=${variantId}.json`)
             .then(response => response.json())
             .then(data => {
                 var variant = data.product;
                 // variants.find(v => v.id == variantId);

                 // Update product details dynamically
                 var newTitle = variant.title + " " + variant.variants[0].option1;
                 // jQuery(that).closest('.product-block').find('.product-block__title').html(newTitle);
                 jQuery(that).closest('.product-block').find('.product-price').textContent = variant.price;
                 // update product url
                 jQuery(that).closest('.product-block').find('.product-link').attr('href', product_url);

                 // Update product image
                 var gallery_images = variant.images;
                 var main_image = variant.image.src;
                 jQuery(that).closest('.product-block').find('.product-block__image img').removeAttr('srcset');
                 jQuery(that).closest('.product-block').find('.product-block__image--primary img').attr('src', main_image);
                 jQuery(that).closest('.product-block').find('.product-block__image--secondary.product-block__image--show-on-hover img').attr('src', gallery_images[1].src);

                 var starting_img_index = 2;
                 jQuery(gallery_images).each(function(i, v) {
                     if (jQuery(that).closest('.product-block').find('.product-block__image img')[starting_img_index]) {
                         if (jQuery(that).closest('.product-block').find('.product-block__image img')[starting_img_index].src) {
                             jQuery(that).closest('.product-block').find('.product-block__image img')[starting_img_index].src = gallery_images[starting_img_index].src;
                         }
                     }
                     starting_img_index++;
                 })
                 // var imageElement = document.querySelector('.product-block__image--primary img');
                 // imageElement.src = variant.featured_image.src;

                 // (Optional) If you have a list of secondary images for each variant
                 // Update other images accordingly
             });
     });
     if (jQuery('.option-selector')[0]) {
         let selected_color = jQuery('.option-selector label.selected').data('color');
         jQuery('.current-color-variant').text(selected_color);
     }
     jQuery('.color-swatches .option-selector label').hover(function() {
         jQuery('.current-color-variant').text(jQuery(this).data('color'));
     }, function() {
         jQuery('.current-color-variant').text(jQuery('.option-selector label.selected').data('color'));
     });
     jQuery('.opt-label.opt-label--btn').on('click', function() {
         if (jQuery(this).attr('title') === "Sold out") {
             jQuery('.klaviyo-bis-trigger').removeClass('d-none');
             jQuery('.klaviyo-bis-trigger').addClass('d-block');
         } else {
             jQuery('.klaviyo-bis-trigger').removeClass('d-block');
             jQuery('.klaviyo-bis-trigger').addClass('d-none');
         }
     })
     jQuery('.offcanvas__menu_parent').on('click', function() {
         jQuery('body').toggleClass('overlay-added');
         jQuery('.offcanvas_menu').toggleClass('visible');
         jQuery('.menu-sections').addClass('hidden');
         jQuery('#shop-items-section').removeClass('hidden');
         jQuery('.offcanvas_menu_header a').removeClass('active');
         jQuery('#toggle-shop-section').addClass('active');
     });

     jQuery('#toggle-new-menu').on('click', function() {
         jQuery('body').toggleClass('overlay-added');
         jQuery('.offcanvas_menu').toggleClass('visible');
         jQuery('.menu-sections').addClass('hidden');
         jQuery('#new-items-section').removeClass('hidden');
         jQuery('.offcanvas_menu_header a').removeClass('active');
         jQuery('#toggle-new-section').addClass('active');
     });

     jQuery('#toggle-collections-menu').on('click', function() {
         jQuery('body').toggleClass('overlay-added');
         jQuery('.offcanvas_menu').toggleClass('visible');
         jQuery('.menu-sections').addClass('hidden');
         jQuery('#collections-items-section').removeClass('hidden');
         jQuery('.offcanvas_menu_header a').removeClass('active');
         jQuery('#toggle-collections-section').addClass('active');
     });

     // Toggle submenu visibility
     jQuery('.offcanvas-has-children > a').on('click', function(e) {
         e.preventDefault(); // Prevent default anchor behavior

         var $submenu = jQuery(this).next('.submenu');

         // If the submenu is currently visible, hide it, otherwise show it
         if ($submenu.is(':visible')) {
             $submenu.slideUp();
         } else {
             $submenu.slideDown();
         }
     });
     jQuery('.offcanvas_menu .offcanvas-has-children').first().addClass('first_submenu');

     jQuery('#toggle-new-section').on('click', function() {
         jQuery('.menu-sections').addClass('hidden');
         jQuery('#new-items-section').removeClass('hidden');
         jQuery('.offcanvas_menu_header a').removeClass('active');
         jQuery('#toggle-new-section').addClass('active');
     });

     jQuery('#toggle-shop-section').on('click', function() {
         jQuery('.menu-sections').addClass('hidden');
         jQuery('#shop-items-section').removeClass('hidden');
         jQuery('.offcanvas_menu_header a').removeClass('active');
         jQuery('#toggle-shop-section').addClass('active');
     });

     jQuery('#toggle-collections-section').on('click', function() {
         jQuery('.menu-sections').addClass('hidden');
         jQuery('#collections-items-section').removeClass('hidden');
         jQuery('.offcanvas_menu_header a').removeClass('active');
         jQuery('#toggle-collections-section').addClass('active');
     })
 });

const swiper = new Swiper('.clswiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    // Navigation arrows
    navigation: {
        nextEl: '.pwswiper-button-next',
        prevEl: '.pwswiper-button-prev',
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 50,
        },
    }
});

const thumbnails_slider = new Swiper('.thumbnails_slider', {
    slidesPerView: 3,
    spaceBetween: 10,
    direction: "vertical",
    // Navigation arrows
    navigation: {
        nextEl: '.tswiper-button-next',
        prevEl: '.tswiper-button-prev',
    },
})

// Close offcanvas menu when clicking outside
jQuery(document).on('click', function(e) {
    // Check if the clicked element is outside the offcanvas_menu
    if (!jQuery(e.target).closest('.offcanvas_menu_holder').length && !jQuery(e.target).closest('.offcanvas__menu_parent').length && !jQuery(e.target).closest('#toggle-new-menu').length && !jQuery(e.target).closest('#toggle-collections-menu').length) {
        jQuery('body').removeClass('overlay-added');
        jQuery('.offcanvas_menu').removeClass('visible'); // Hide the menu
    }
});

document.addEventListener('DOMContentLoaded', function() {
    var swatches = document.querySelectorAll('.color-swatches label');

    // Event listener for swatch click
    swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
            // Remove 'selected' class from all labels
            swatches.forEach(function(otherSwatch) {
                otherSwatch.classList.remove('selected');
            });

            // Add 'selected' class to the clicked label
            this.classList.add('selected');

            var url = this.getAttribute('data-url');
            window.location.href = url; // Uncomment this line to redirect to the product URL
        });
    });
})